import {Environment, getEnvironment} from '@/services/infrastructure/envhelper.service'
import {getFeatureValue, TogglableFeature} from '@/feature-toggles/feature-toggler.service'

export const DebugFeature: TogglableFeature = {
    isEnabled: () => {
        return getEnvironment() === Environment.Local && getFeatureValue('show-debug-page', true)
    }
}
